import { OfficeBuildingIcon } from '@heroicons/react/outline';
import clsx from 'clsx';
import { LoadingMask } from '../Loading/LoadingMask';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var NewOrganizationLogo = function NewOrganizationLogo(props) {
  var src = props.src,
      loading = props.loading,
      className = props.className,
      imgClassName = props.imgClassName,
      defaultSrcClassName = props.defaultSrcClassName;
  /**
   * methods
   */

  var showLogoAction = function showLogoAction() {
    if (!src.includes('base64')) {
      window.open(src);
    }
  };

  return /*#__PURE__*/_jsxs("div", {
    className: clsx('flex w-auto items-center justify-center overflow-hidden rounded', className),
    children: [loading && /*#__PURE__*/_jsx(LoadingMask, {}), src ? /*#__PURE__*/_jsx("img", {
      src: src,
      alt: "logo",
      className: clsx('h-full w-auto', src.includes('base64') ? '' : 'cursor-pointer', imgClassName),
      onClick: showLogoAction
    }) : /*#__PURE__*/_jsx(OfficeBuildingIcon, {
      className: clsx('h-10 text-black/70', defaultSrcClassName)
    })]
  });
};